class lazyLoad {
  options = {
    imgClassName: ".lazy"
  }
  imgs = [] //需要懒加载的图片集合
  isHasEmptyImg = true //是否存在空的img标签
  constructor(options={}) {
    this.options = {
      ...this.options,
      ...options,
    };
    this.init();
  }
  init() {
    this.imgs = Array.from(document.querySelectorAll(this.options.imgClassName));
    this.viewHeight = window.innerHeight;

    window.addEventListener('scroll', () => {
      for (let i = 0; i < this.imgs.length; i++) {
        const el = this.imgs[i];
        if (this.isInSight(el) && this.isEmptySrc(el)) {
          const src = el.getAttribute('data-src');
          el.setAttribute('src', src);
          this.imgs.splice(i,1)
        }
      }
    })
  }
  isInSight(el) {
    const bound = el.getBoundingClientRect();
    return bound.top <= this.viewHeight + 200; // 这里有个+200是为了提前加载。
  }
  isEmptySrc(el) {
    return !el.getAttribute('src')
  }
}
export default lazyLoad